// import { Home, Grid, FileText, User } from 'lucide-react';
// import { useNavigate, useLocation } from 'react-router-dom';

// export default function BottomNavigationCustomer() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const isActive = (path: string) => location.pathname === path;

//   return (
//     <div className="fixed bottom-0 w-full bg-white border-t flex justify-around py-2 text-sm z-50 shadow-lg">
//       <div
//         onClick={() => navigate('/customer-home-page')}
//         className={`flex flex-col items-center ${isActive('/customer-home-page') ? 'text-[#38bdff]' : 'text-gray-600'}`}
//       >
//         <Home className="w-5 h-5" />
//         <span className="font-semibold text-xs">Home</span>
//       </div>

//       <div
//         onClick={() => navigate('/all-services')}
//         className={`flex flex-col items-center ${isActive('/all-services') ? 'text-[#38bdff]' : 'text-gray-600'}`}
//       >
//         <Grid className="w-5 h-5" />
//         <span className="text-xs">Services</span>
//       </div>

//       <div
//         onClick={() => navigate('/customer-activity')}
//         className={`flex flex-col items-center ${isActive('/customer-activity') ? 'text-[#38bdff]' : 'text-gray-600'}`}
//       >
//         <FileText className="w-5 h-5" />
//         <span className="text-xs">Updates</span>
//       </div>

//       <div
//         onClick={() => navigate('/user-profile-section')}
//         className={`flex flex-col items-center ${isActive('/user-profile-section') ? 'text-[#38bdff]' : 'text-gray-600'}`}
//       >
//         <User className="w-5 h-5" />
//         <span className="text-xs">Account</span>
//       </div>
//     </div>
//   );
// }

import React from 'react'
import { Link, useLocation } from 'react-router-dom';

function BottomNavigationCustomer() {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Injected styles inside JSX */}
      <style>{`
        .new-bottom-footer {
          height: 90px;
          width: 100%;
          background-color: white;
          position: fixed;
          bottom: 0;
          display: flex;
          justify-content: space-around;
          align-items: flex-start;
          border-top-left-radius: 24px;
          border-top-right-radius: 24px;
          box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.1);
          padding-top: 10px;
        }

        .bottom-block {
          display: flex;
          flex-direction: column;
          align-items: center;
          color: grey;
          font-size: 12px;
        }

        .bottom-block .icon-circle {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background-color: transparent;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 24px;
          transition: all 0.3s;
        }

        .bottom-block i {
          color: grey;
        }

        .bottom-block p {
          display: none;
          margin-top: 6px;
          font-size: 12px;
        }

        .bottom-block.active .icon-circle {
          background-color: #21A6E9;
        }

        .bottom-block.active i {
          color: white;
          font-size: 18px;
          margin-top: -5px;
        }

        .bottom-block.active p {
          display: block;
          color: #21A6E9;
          font-weight: 500;
        }

        .none {
          text-decoration: none;
        }

        @media(max-width:361px){
          .newservices-boxs { width: 130px; }
          .services-boxs { gap: 10px; }
        }

        .bookbox-steper {
          display: flex;
          flex-direction: row;
          align-items: start;
          justify-content: center;
          gap: 15px;
          color: #21A6E9;
        }

        .bookbox-steper-div {
          height: 50px;
          width: 50px;
          border: 1px solid #21A6E9;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .bookbox-steper p {
          margin-top: 5px;
          font-size: 10px;
          text-align: center;
        }

        .bookbox-steper-div-section {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }

        @media(max-width:370px){
          .bookbox-steper-div {
            height: 40px;
            width: 40px;
          }

          .bookbox-steper {
            gap: 10px;
          }
        }
      `}</style>

      {/* Footer */}
      <div className='font-satoshi new-bottom-footer'>
        <Link className='none' to='/customer-home-page'>
          <div className={`bottom-block ${isActive('/customer-home-page') ? 'active' : ''}`}>
            <div className="icon-circle">
              <i className="bi bi-house-door-fill"></i>
            </div>
            {isActive('/customer-home-page') && <p>Home</p>}
          </div>
        </Link>

        <Link className='none' to='/all-services'>
          <div className={`bottom-block ${isActive('/all-services') ? 'active' : ''}`}>
            <div className="icon-circle">
              <i className="bi bi-file-earmark-fill"></i>
            </div>
            {isActive('/all-services') && <p>Services</p>}
          </div>
        </Link>

        <Link className='none' to='/customer-activity'>
          <div className={`bottom-block ${isActive('/customer-activity') ? 'active' : ''}`}>
            <div className="icon-circle">
              <i className="bi bi-star-fill"></i>
            </div>
            {isActive('/customer-activity') && <p>Updates</p>}
          </div>
        </Link>

        <Link className='none' to='/user-profile-section'>
          <div className={`bottom-block ${isActive('/user-profile-section') ? 'active' : ''}`}>
            <div className="icon-circle">
              <i className="bi bi-person-fill"></i>
            </div>
            {isActive('/user-profile-section') && <p>Profile</p>}
          </div>
        </Link>
      </div>
    </>
  );
}

export default BottomNavigationCustomer;
